<p-autoComplete
  #autoCompleteRef
  styleClass="key-accounts"
  [(ngModel)]="selectedKeyAccount"
  [suggestions]="optionsList"
  [dropdown]="true"
  [completeOnFocus]="true"
  [placeholder]="'FIXTURE_LIBRARY.SELECT_KEY_ACCOUNT' | translate"
  (completeMethod)="searchKeyAccount($event)"
  (onSelect)="selectKeyAccount($event)"
  (onClear)="clearKeyAccount()"
  field="name"
  [showClear]="true"
>
  <ng-template let-account pTemplate="item">
    <div class="key-account-name">
      {{ account.name }}
    </div>
    <div class="key-account-country">
      {{ account.country }}|
      {{ account.region }}
    </div>
  </ng-template>
</p-autoComplete>
